<template lang="pug">
  .input(:class="classes")
    //- img.input__pic(:src="getImgUrl(input.pic)")
    .input__slider-desc
      |{{input.placeholder}} 
      span.input__slider-value
        |  {{sliderValue || options[input.start]}}
    input.input__control(v-model="inputValue", disabled, ref="input", v-validate="input.validateRules", :name="input.name", type="text", @focus="handleFocus", @blur="handleBlur", @input="handleInput")
    vue-slider(v-model="sliderValue", :data="getData", @change="handleSliderChange")
    //- .input__error(v-if="isError")
      |{{errors.first(input.name)}}

</template>

<script>
  import Inputmask from 'inputmask';
  import VueSlider from 'vue-slider-component'
  import 'vue-slider-component/theme/antd.css'
export default {

  inject: ['$validator'],
  props:{
    input: null,
    options:null
  },
  name: 'app-slider-input',
  components: {
    VueSlider
  },
  data() {
    return {
      sliderValue:this.options[this.input.start].name,
      inputValue:'',
      isFocus: false
    }
  },
  mounted() {
    
  },
  methods:{
    
    handleFocus(){
      
    },

    handleBlur(){

      if(this.isEmpty) {
        this.isFocus = false;
      }
      // this.$emit('handleBlur');
    },
    handleInput(e){
      
    },
    handleSliderChange(value){
      const item = this.options.filter(prop => prop.name === value);
      this.$store.dispatch(this.input.name, item[0]);
      // console.log(item, value)
    }
  },
  computed:{
    isError() {
      return this.errors.has(this.input.name);
    },
    isEmpty() {
      if (this.inputValue) {
          return false;
      } else {
          return true;
      }
    },
    classes() {
      return {
        'is_status-focus': this.isFocus || !this.isEmpty,
        'is_status-error': this.isError,
        'is_status-valid': !this.isEmpty && !this.isError,
        'is_status-disabled': this.isDisabled
      };
    },
    getData(){
      return this.options.map(item => item.name)
    }
  }
}
</script>

<style lang="scss">
  .input {
    &__slider-desc {
      position: absolute;
      top: 17px;
      left: 16px;
      font-size: 17px;
      color: #808080;
      font-weight: 400;
    }
    &__slider-value {
      color:$primary;
      font-weight: 700;
    }
  }
  .vue-slider:hover .vue-slider-dot-handle:hover {

  }
  .vue-slider {
    width: 100%;
    position: relative;
    box-sizing: content-box;
    user-select: none;
    display: block;
    -ms-touch-action: none;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    outline: none;
    -webkit-appearance: none;
    background: transparent;
    margin-top: -8px;
    &-rail {
        // width: calc(100% - 45px) !important;
        width: 80% !important;
        background-color: transparent !important;
        margin-left: 10%;
        margin-right: 10%;
        &:hover {
          background-color: transparent;
        }
    }
    &-dot {
      height: 18px !important;
      width: 42px !important;
      border-radius: 10px;
      box-shadow: -1px 1px 9px -1px $primary !important;
      &-tooltip {
        display: none;
      }
      &-handle {
        border: 3px solid #fff !important;
        height: 18px !important;
        width: 42px !important;
        border-radius: 10px;
        background-image: url(../assets/img/arrowlr.png);
        background-repeat: no-repeat;
        background-position: center;
        background-color: $primary;
        background-size: 30px 10px;
        cursor: pointer;
        &-focus {
          box-shadow: -1px 1px 9px -1px $primary !important;
        }
      }
    }
    &-process {
      background-color: transparent !important;
      &:hover {
        background-color: transparent;
      }
    }
  }
  .noUi-horizontal .noUi-handle {
    background-color: $primary;
    z-index: 1;
    position: absolute;
    margin-top: -9px;
    width: 44px;
    height: 20px;
    border-radius: 50px;
    box-shadow: -1px 1px 9px -1px $primary;
    border: 3px solid #ffffff;
    cursor: pointer;
  }
  

</style>
